import { render, staticRenderFns } from "./Macchina.vue?vue&type=template&id=68aa1bd2&"
import script from "./Macchina.vue?vue&type=script&lang=js&"
export * from "./Macchina.vue?vue&type=script&lang=js&"
import style0 from "./Macchina.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports